import { applyMiddleware, configureStore } from '@reduxjs/toolkit'
import { composeWithDevTools } from 'redux-devtools-extension'
import createSagaMiddleware from 'redux-saga'

import rootReducer from './reducers'
import rootSaga from './sagas'

const sagaMiddleware = createSagaMiddleware()
const middlewares = [sagaMiddleware]

export const store = configureStore({
  reducer: rootReducer,
  middleware: [sagaMiddleware],
})

composeWithDevTools(applyMiddleware(...middlewares))

sagaMiddleware.run(rootSaga)
